"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _trends = require("@/api/cont/trends");
var _storage = require("@/api/storage");
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _auth = require("@/utils/auth");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _cropper = _interopRequireDefault(require("@/components/cropper.vue"));
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    MultiLanguageInp: _MultiLanguageInp.default,
    Tinymce: _Tinymce.default,
    Cropper: _cropper.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      uploadPath: _storage.uploadPath,
      total: 0,
      type: 0,
      pageSize: 10,
      currentPage: 1,
      tit: '新增',
      id: '',
      staus: 1,
      // 1新增 2编辑
      fileList: [],
      form: {
        date: '',
        zipCode: '',
        title: '',
        text: '',
        enable: false,
        brief: '',
        contentZh: '',
        contentEn: null,
        contentEs: null,
        detailZh: '',
        detailEn: null,
        detailEs: null,
        tagList: [],
        url: ''
      },
      dataSource: [],
      tag: [],
      selectedKeys: [],
      props: {
        multiple: true,
        checkStrictly: true,
        value: "id",
        label: "name",
        children: 'childList',
        emitPath: false
      },
      value: '',
      activeName1: 'zh',
      activeName2: 'zh',
      oldIndex: null,
      newIndex: null,
      uploadDia: false,
      btnLoading: false
    };
  },
  computed: {
    headers: function headers() {
      return {
        'Mu-Token': (0, _auth.getToken)()
      };
    }
  },
  mounted: function mounted() {
    this.type = this.$route.meta.type;
    this.getList();
    console.log(this.$route);
    this.handleGetTagList();
    this.init();
  },
  methods: {
    init: function init() {
      // 1. 获取拖拽元素的父元素
      // 因为使用的element的table 所以可直接获取tbody
      var el = document.querySelector(".el-table__body-wrapper tbody");
      var _this = this;
      // 2. 创建并配置相关参数
      var sortable = new _sortablejs.default(el, {
        forceFallback: true,
        // 此处进行配置 及 回调函数的使用
        handle: '.handle_move',
        // css选择器的字符串 若设置该值，则表示只有按住拖动手柄才能使列表单元进行拖动
        draggable: '.el-table__row',
        // 允许拖拽的项目类名
        // 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
        // 拖拽中 回调函数
        onMove: function onMove(customEvent) {
          // 禁止在拖拽过程中交换位置
          // 可将初始位置及目标位置进行记录
          _this.oldIndex = customEvent.dragged.rowIndex; //  初始位置
          _this.newIndex = customEvent.related.rowIndex; // 目标位置
          console.log(_this.oldIndex, _this.newIndex, 's');
          return false;
        },
        // 拖拽结束，调整位置
        onEnd: function onEnd() {
          // 在拖拽结束后，获取初始及目标位置
          var newIndex = _this.newIndex,
            oldIndex = _this.oldIndex;
          var currRow = _this.dataSource.splice(oldIndex, 1)[0];
          _this.dataSource.splice(newIndex, 0, currRow);
          // 拖拽完成，初始位置及目标位置重置
          _this.newIndex = null;
          _this.oldIndex = null;
          var dataSource = _this.dataSource.map(function (item) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
              type: _this.type
            });
          });
          (0, _trends.cmsUpdateOrSaveBatch)(dataSource).then(function (res) {});
        }
      });
    },
    handleClick: function handleClick(data) {},
    onEnable: function onEnable(val, value) {
      console.log('val', val, value);
      var data = {
        date: value.date,
        text: value.text,
        title: value.title,
        type: this.type,
        id: value.id,
        zipcode: value.zipCode,
        enable: val,
        brief: value.brief,
        url: value.url
      };
      (0, _trends.updateApi)(data).then(function (res) {
        // this.getList()
      });
    },
    // 删除
    deleteItem: function deleteItem(item) {
      var _this2 = this;
      (0, _trends.deleteApi)({
        id: item.id
      }).then(function (res) {
        console.log(res);
        _this2.getList();
      });
    },
    getList: function getList() {
      var _this3 = this;
      var params = {
        type: this.type,
        page: this.currentPage,
        size: this.pageSize
      };
      (0, _trends.pageApi)(params).then(function (res) {
        console.log(res);
        _this3.dataSource = res.data.data.list;
        _this3.total = res.data.data.total;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getList();
    },
    add: function add() {
      this.dialogVisible = true;
      // this.form = {}
      this.form = {
        date: '',
        zipCode: '',
        title: '',
        text: '',
        enable: false,
        brief: '',
        contentZh: '',
        contentEn: null,
        contentEs: null,
        detailZh: '',
        detailEn: null,
        detailEs: null,
        tagList: [],
        url: ''
      };
      this.selectedKeys = [];
      this.staus = 1;
    },
    edit: function edit(item) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.form = {
          date: '',
          zipCode: '',
          title: '',
          text: '',
          enable: false,
          brief: '',
          contentZh: '',
          contentEn: null,
          contentEs: null,
          detailZh: '',
          detailEn: null,
          detailEs: null,
          url: ''
        };
        _this4.dialogVisible = true;
        _this4.tit = '编辑';
        _this4.staus = 2;
        _this4.id = item.id;
        _this4.form = _lodash.default.cloneDeep(item);
        _this4.form.date = [item.date, item.endDate ? item.endDate : item.date];
        _this4.selectedKeys = item.tagList ? item.tagList.map(function (item1) {
          return item1.id;
        }) : [];
        _this4.tagList = item.tagList;
      });
    },
    sure: function sure() {
      var _this5 = this;
      // 使用 Object.values() 方法将 form 对象的所有值转换为数组
      var values = Object.keys(this.form);
      // 使用 Array.every() 方法判断数组中的每个值是否为空
      var isFormEmpty = values.filter(function (key) {
        return key !== 'enable';
      }).every(function (key) {
        return _this5.form[key] === '';
      });
      if (isFormEmpty) {
        this.$message.warning('请输入信息');
        return;
      }
      var data = {
        date: this.form.date[0],
        endDate: this.form.date[1],
        text: this.form.text,
        title: this.form.title,
        type: this.type,
        id: this.id,
        zipcode: this.form.zipCode,
        enable: this.form.enable,
        brief: this.form.brief,
        contentZh: this.form.contentZh,
        contentEn: this.form.contentEn,
        contentEs: this.form.contentEs,
        detailZh: this.form.detailZh,
        detailEn: this.form.detailEn,
        detailEs: this.form.detailEs,
        tagList: this.form.tagList,
        url: this.form.url
      };
      if (this.staus == 1) {
        (0, _trends.trendsCreateApi)(data).then(function (res) {
          if (res.data.errno == 0) {
            _this5.$message.success('添加成功');
            _this5.dialogVisible = false;
            _this5.getList();
          }
        });
      }
      if (this.staus == 2) {
        (0, _trends.updateApi)(data).then(function (res) {
          console.log(res);
          _this5.$message.success('编辑成功');
          _this5.dialogVisible = false;
          _this5.getList();
        });
      }
    },
    routeLabel: function routeLabel() {
      this.$router.push({
        path: '/labelManagement',
        query: {
          type: 4
        }
      });
    },
    handleGetTagList: function handleGetTagList() {
      var _this6 = this;
      (0, _trends.getTagList)({
        type: 4
      }).then(function (res) {
        _this6.tag = res.data.list;
        _this6.tag.forEach(function (item) {
          item.disabled = true;
          item.name = _this6.multiLanguageDisplay(item.name);
          if (item.childList) {
            item.childList.forEach(function (item1) {
              item1.name = _this6.multiLanguageDisplay(item1.name);
            });
          }
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(selectedIds) {
      // 根据选中的 ID 数组过滤出完整对象
      var _getSelectedObjects = function getSelectedObjects(options, selectedIds) {
        var result = [];
        options.forEach(function (option) {
          if (selectedIds.includes(option.id)) {
            result.push(option);
          }
          if (option.childList) {
            result = result.concat(_getSelectedObjects(option.childList, selectedIds));
          }
        });
        return result;
      };
      this.form.tagList = _getSelectedObjects(this.tag, selectedIds);
      console.log("选中的对象:", this.form.tagList);
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      console.log(res);
      this.form.url = res.data.url;
      console.log(this.form.url);
    },
    openCropper: function openCropper(file, fileList) {
      var _this7 = this;
      var isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return false;
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      //   return false
      // }
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // base64方式
              // this.option.img = await fileByBase64(file.raw)
              console.log(file, fileList);
              _this7.img = URL.createObjectURL(file.raw);
              // this.loading = false
              _this7.uploadDia = true;
            case 1:
              return _context.a(2);
          }
        }, _callee);
      })));
    },
    handleOk: function () {
      var _handleOk = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var cropData, file, formData, response, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.btnLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return this.$refs.iconShot.getCropData();
            case 2:
              cropData = _context2.v;
              console.log(cropData, 'cop');
              file = new File([cropData.blob], 'pic.png', {
                type: "image/png" // 图片类型
              }); // 创建 FormData 对象
              formData = new FormData();
              formData.append("file", file); // 文件名为 "file"
              // 上传到接口
              _context2.n = 3;
              return _axios.default.post(_storage.uploadPath, formData, {
                headers: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.headers), {}, {
                  "Content-Type": "multipart/form-data" // 必须是 multipart/form-data
                })
              });
            case 3:
              response = _context2.v;
              // 成功上传后处理
              console.log("Upload successful:", response.data);
              this.form.url = response.data.data.url;
              this.uploadDia = false; // 关闭对话框
              this.btnLoading = false;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error("Error uploading file:", _t);
              this.btnLoading = false;
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function handleOk() {
        return _handleOk.apply(this, arguments);
      }
      return handleOk;
    }()
  }
};